import {
  DrawerHeader,
  DrawerHeaderRef,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import SVGLOGO from 'assets/caesars_rewards_light.svg';
import React, {forwardRef} from 'react';

import {APP_BASE_URL, Routes} from 'models/Navigation';
import {navigateOrOpenUrl} from 'utils/navigation';

export interface ConnectedDrawerHeaderProps {
  onToggle?: (isOpen: boolean) => void;
  onHomePressed?: () => void;
}

const ConnectedDrawerHeader = forwardRef<
  DrawerHeaderRef,
  ConnectedDrawerHeaderProps
>(({onToggle}, ref) => {
  const isLoggedIn = useWidgetState(Selectors.isLoggedInSelector) as boolean;
  const navigateToHome = () => {
    navigateOrOpenUrl({
      legacyUrl: isLoggedIn ? '/myrewards/profile' : '/myrewards',
      newRewardsScreen: Routes.Main.Home,
    });
  };

  const homeButtonHref = window.isLegacyMyRewards
    ? '/myrewards'
    : `/${APP_BASE_URL}`;

  const legacyMyRewardsHelper = (isOpen: boolean) => {
    if (window.isLegacyMyRewards) {
      window?.toggleDivs && window?.toggleDivs(isOpen);
    }
  };

  return (
    <DrawerHeader
      svgLogo={SVGLOGO}
      ref={ref}
      onToggle={onToggle}
      onHomePressed={navigateToHome}
      homeButtonHref={homeButtonHref}
      logoAltText="Navigate To My Rewards Home Screen"
      logoButtonAccessibilityLabel="Caesars Rewards My Rewards Home"
      legacyMyRewardsHelper={legacyMyRewardsHelper}
    />
  );
});

export default ConnectedDrawerHeader;
